var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('vtoast',{ref:"vtoast"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }